import { environment } from '../enviroments';
import { isPlatform } from '@ionic/react';
import { HttpHandler } from './HttpHandler';

export const getUserHash = async (userID: string) => {
  const platform =
    isPlatform('hybrid') && isPlatform('android')
      ? 'android'
      : isPlatform('hybrid') && isPlatform('ios')
        ? 'ios'
        : 'web';

  const userHash = await HttpHandler({
    method: 'POST',
    url: `${environment.INTERCOM_URL}/user-hash/${platform}/${userID}`,
  });

  return userHash.data.data as string;
};
